import styled from 'styled-components';

export const EditCellContent = styled.div.attrs<{ className?: string }>({
  className: 'table-cell-content md:min-h-[88px]',
})`
  margin: 0;

  .feature-flags-head {
    color: var(--color-text-muted);
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    padding: 0 0 22px;
  }

  .feature-flags-list {
    display: flex;
    align-items: center;
    gap: 30px;
    flex-wrap: wrap;

    .feature-flag {
      flex: 0 0 auto;
      display: flex;
      gap: 10px;
      align-items: center;
      max-width: 100%;

      .label {
        color: var(--color-text-muted);
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 100%;
      }
    }
  }
`;
